import { useMemo } from "react";
import { SubGroupSupportedExchanges } from "@shared/types";

export const useSupportedExchanges = (
  supportedExchanges: SubGroupSupportedExchanges
) => {
  return useMemo(
    () =>
      Object.entries(supportedExchanges)
        ?.map(([exchange, exchangeData]) => {
          return { exchange, ...exchangeData };
        })
        .filter((exchange) => exchange.number_of_signals)
        .slice()
        .sort((a, b) => b.number_of_signals - a.number_of_signals),
    [supportedExchanges]
  );
};
